// Auto-Tag — portal entry (owned by the autotag feature).
// Rules list, builder (new / edit, with templates + "Test on 10 contacts") and a rule's results.
import { Tags } from "lucide-react";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const autotag: FeatureModule = {
  id: "autotag",
  nav: [{ to: "/autotag", label: "Auto-Tag", icon: Tags, group: "pipeline", order: 25 }],
  routes: [
    {
      path: "/autotag",
      lazy: async () => {
        const { RulesPage } = await import("./RulesPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <RulesPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/autotag/new",
      lazy: async () => {
        const { BuilderPage } = await import("./BuilderPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <BuilderPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/autotag/:ruleId",
      lazy: async () => {
        const { RulePage } = await import("./RulePage");
        return {
          Component: () => (
            <RequireIgAccount>
              <RulePage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/autotag/:ruleId/edit",
      lazy: async () => {
        const { BuilderPage } = await import("./BuilderPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <BuilderPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default autotag;
